<script>
import { getCellWidth } from '@/utils/data-table';

const ALIGN_CLASSES = {
  left: '',
  right: 'mds-data-table__cell--right',
};

export default {
  functional: true,
  render(h, { data, props, children }) {
    const {
      align, width, nowrap, ...restProps
    } = props;
    const staticClass = `mds-data-table__cell ${ALIGN_CLASSES[align] || ''} ${data.staticClass || ''}`;

    const newData = {
      ...data,
      staticClass,
      attrs: {
        ...restProps,
        role: 'gridcell',
        scope: 'row',
        width: getCellWidth(width) || undefined,
        nowrap: nowrap || undefined,
      },
    };

    return h('td', newData, children);
  },
};
</script>
